/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { DropdownMenuItem, DropdownMenuSeparator } from '@repo/shared-client/components/ui'
import { UserRole } from '@repo/shared-common'
import { useAuth } from '@web/src/hooks/use-auth'
import { useTranslation } from '@web/src/lib/intl/react'

type MediaAdminEditMenuItemsProps = {
  mediaId: string
  onOpen: () => void
  showSeparator?: boolean
}

const MediaAdminEditMenuItems = ({ mediaId, onOpen, showSeparator = true }: MediaAdminEditMenuItemsProps) => {
  const { t } = useTranslation()
  const { isAtLeastRole } = useAuth()
  const canReviewMedia = isAtLeastRole(UserRole.MODERATOR)

  if (!canReviewMedia) {
    return null
  }

  if (!mediaId) {
    return null
  }

  return (
    <>
      {showSeparator ? <DropdownMenuSeparator /> : null}
      <DropdownMenuItem onClick={onOpen}>{t('Admin Edit')}</DropdownMenuItem>
    </>
  )
}

export default MediaAdminEditMenuItems
